export class FbSubmitModalConfiguration {
    Oid : number;
    AuctionName: string;
    Address: string | null;
    StartingPrice: number;
    BidQuantity: number;
    Offer: number;

    constructor(oid: number, auctionName: string, startingPrice: number, bidQuantity : number) {
        this.Oid = oid,
        this.AuctionName = auctionName,
        this.StartingPrice = startingPrice,
        this.BidQuantity = bidQuantity
    }
        public static create = (

            oid : number,
            auctionName: string,
            startingPrice,
            bidQuantity : number

        ) =>
            new FbSubmitModalConfiguration(
                oid,
                auctionName,
                startingPrice,
                bidQuantity
            );

    setAddress(address: string) {

        this.Address = address;
        return this;

    }

    setOffer(offer: number) {

        this.Offer = offer;
        return this;

    }


}
